import React, { useState } from 'react'
 
 
import VansaleGoodIssueList from './VansaleGoodIssueList';
import VansaleGoodIssueForm from './VansaleGoodIssueForm';

const VansaleGoodIssue= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <VansaleGoodIssueForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <VansaleGoodIssueList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}  
    </>
  )
}

export default VansaleGoodIssue